<ng-container *ngIf="error$ | async as error; else showForm">
    <fc-signup-error
        [errorType]="error"
        [actionButtonLabel]="'SIGNUP.ACCOUNT_VERIFICATION.BUTTON.LABEL' | translate"
        (actionButtonClicked)="retry()"
    ></fc-signup-error>
</ng-container>
<ng-template #showForm>
    <form class="fc-signup-form" [formGroup]="signupForm">
        <fc-organization-type-selection
            *ngIf="step === 0"
            formControlName="organizationType"
            (ngModelChange)="gotoStep(1)"
        >
        </fc-organization-type-selection>

        <div
            *ngIf="step === 1 || (isInOrderSignupFlow && step === 2)"
            class="fc-signup-form-container"
            id="fc-signup-form-container"
        >
            <div class="fc-signup-form-header">
                <span
                    *ngIf="signupForm.value.organizationType === organizationTypes.Retailer"
                    class="fc-signup-form-header-title"
                >
                    {{ 'SIGNUP.FORM.TITLE.RETAILER' | translate }}
                </span>
                <span
                    *ngIf="signupForm.value.organizationType === organizationTypes.Manufacturer"
                    class="fc-signup-form-header-title"
                >
                    {{ 'SIGNUP.FORM.TITLE.MANUFACTURER' | translate }}
                </span>
            </div>
            <div class="fc-signup-form-content">
                <fc-organization-info-form
                    [hidden]="step !== 1"
                    [organizationType]="signupForm.value.organizationType"
                    [showPrevButton]="!!organizationTypeEditable"
                    (backClicked)="gotoStep($event)"
                    (organizationLookupClicked)="onOrganizationLookupClicked($event)"
                    (organizationFormSubmitted)="onOrganizationFormSubmitted($event)"
                ></fc-organization-info-form>
                <fc-store-info-form
                    [hidden]="!isInOrderSignupFlow || (step !== 2 && isInOrderSignupFlow)"
                    (backClicked)="gotoStep(1)"
                    (storeFormSubmitted)="onStoreFormSubmitted($event)"
                >
                </fc-store-info-form>
            </div>
        </div>
        <fc-organization-exists
            *ngIf="step === -1"
            [organization]="selectedOrganization"
            [isReferral]="!!referral"
            (backClicked)="step = 1"
            (finishRequestClicked)="onExistingOrgFinishRequestClicked($event)"
        >
        </fc-organization-exists>

        <fc-signup-sent
            *ngIf="step === totalSteps + 1"
            [origin]="userIsJoiningExistingOrganization ? 'existingOrgSignup' : 'normalSignup'"
        ></fc-signup-sent>
    </form>
</ng-template>
